<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
    <div>
      <v-alert v-if="alert" :type="alert_type" :value="alert" transition="scale-transition" >{{ alert_message }}</v-alert >
    </div>
    <!-- Title-->
    <header-component :headerTitle="headerText" />
    <!-- Request tracker tab popups -->
    <v-row justify="center">
      <v-dialog v-model="dialogDetails" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Create Request Screen</span>
            <v-spacer></v-spacer>
            <v-btn variant='solo' icon @click="dialogDetailsClose">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0" />
          <v-form>
            <v-card-text>
              <v-container>
                <v-row justify="center">
                  <v-col cols="12">
                    <v-combobox color="blue" v-model="select_location" :items="location_items" item-title="code" item-value="code" label="Select Location" variant="outlined" @update:modelValue="subLocationChange"></v-combobox>
                  </v-col>
                </v-row>
                <span>Inventory:</span>
                <v-radio-group v-model="selectedOption" row @change="updateSelectedoption" inline class="mt-6">
                  <v-radio  label="All" value="all_inventory" class="mr-12"></v-radio>
                  <v-radio  label="Partial" value="partial" :disabled="isPartialOptionDisabled"></v-radio>
                </v-radio-group>
                <div>
                  <v-row>
                    <v-col cols="12">
                      <!-- sub location id -->
                      <v-combobox 
                         color="blue" 
                         v-model="sub_location_id" 
                         :items="sub_location_id_items" 
                         item-title="code" 
                         item-value="code" 
                         label="Sub Location ID" 
                         multiple 
                         variant="outlined" 
                         :disabled="selectedOption === 'all_inventory' || inspection_file !== null" 
                         @update:modelValue="handleAutocompleteInput('sub_location_id')" ref="searchLocationIdClear"> 
                         </v-combobox>
                      <template v-for="(item, index) in selectedLocationId">
                        <p :key="index" class="addeditems" v-if="item.code">
                          {{ item.code }}
                          <v-btn variant="solo" icon @click="removeSelectedItem('sub_location_id', index)" class="closeitems">
                            <v-icon style="margin-top:-3px; font-size:16px">mdi-close</v-icon>
                          </v-btn>
                        </p>
                      </template>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                     <div style="position: relative; display: inline-block; width: 100%;">
                      <v-file-input color="blue" v-model="inspection_file" accept=".csv" label="Upload Inspection file" variant="outlined" prepend-icon="" prepend-inner-icon="mdi-paperclip" @change="handleFileUpload" ref="fileInput" 
                      :disabled="selectedOption === 'all_inventory' || selectedLocationId.length > 0" ></v-file-input>
                      <a href="#" class="link-text" :class="{'disabled-link' : selectedOption === 'all_inventory' || selectedLocationId.length > 0}" style="position: absolute; right: 2px;; bottom: 0" @click="downloadSampleFile">Download Sample File</a>
                     </div>
                    </v-col>
                  </v-row>
                  </div>
                  <span>Select the Physical Inspection Executives</span>
                  <v-row class="mt-2">
                    <v-col cols="12">
                      <v-combobox color="blue" v-model="search_id_names_select" :items="search_id_names_items" item-title="full_name" item-value="id" label="search by ID or first/last names" multiple variant="outlined" @update:modelValue="handleAutocompleteInput('search_id_names_select')"  @keyup="searchItems($event)" ref="searchClear"> </v-combobox>
                      <template v-for="(item, index) in selectednameItems">
                        <p :key="index" class="addeditems" v-if="item.full_name">
                          {{ item.full_name }}
                          <v-btn variant="solo" icon @click="removeSelectedItem('search_id_names_select', index)" class="closeitems">
                            <v-icon style="margin-top:-3px; font-size:16px">mdi-close</v-icon>
                          </v-btn>
                        </p>
                      </template>
                    </v-col>
                  </v-row>
              </v-container>
            </v-card-text>
          </v-form>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn variant="outlined" size="small" color="primary" class="cancel-color mb-3 text-none" @click="dialogDetailsClose">Cancel</v-btn>
            <v-btn variant="flat" :color="isSubmitDisabled ? '' : 'primary'" size="small" class="mb-3 text-none" :disabled="isSubmitDisabled" @click="requestSubmission">Submit</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!--  Success message popup -->
    <v-row justify="center">
      <v-dialog v-model="successpopup" persistent max-width="424px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="successpopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="text-center">
            <span> {{ successmessage }}</span>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn color="primary" variant="flat" class="mb-3 text-none" @click="afterClickOkLoadData"
              >Ok</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Item Issue tab popup -->
    <v-row justify="center">
      <v-dialog v-model="writeoffpopup" persistent max-width="500px">
        <v-form>
          <v-card class="v-card-100">
            <v-card-title class="d-flex align-center">
              <v-spacer>Write Off</v-spacer>
              <v-spacer></v-spacer>
              <v-btn variant="solo" icon @click="closeeriteoff">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider :thickness="4" class="m-0" />
            <v-card-text class="text-center" v-if="$isRelianceClient()">
                <span>Do you want to write off?</span>
             </v-card-text>
              <v-card-text v-else>
              <v-container>
                <v-row>
                    <v-col cols="12" sm="4" md="12">
                      <v-text-field  label="Remarks" variant="outlined" v-model="remarks" type="text"></v-text-field>
                    </v-col>
                  </v-row>
                  <!-- <v-checkbox v-model="showDebitNote" label="With Debit Note" @change="handleCheckboxChange('showDebitNote')"></v-checkbox>
                <v-checkbox
                  v-model="showWithoutDebitNote"
                  label="Without Debit Note"
                  @change="handleCheckboxChange('showWithoutDebitNote')"
                ></v-checkbox>

                <div v-if="showDebitNote">
                  <v-row>
                    <v-col cols="6">
                      <v-combobox
                        v-model="vendor_code"
                        :items="vendor_data"
                        item-title="vendor_code"
                        item-value="id"
                        label="Vendor Code"
                        variant="outlined"
                        color = 'blue'
                        @keyup="searchVendor($event)"
                        ref="vendorsearchClear"
                      ></v-combobox>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        prepend-inner-icon="mdi-magnify"
                        v-model="formattedDebitAmount"
                        label="Debit Amount (₹)"
                        color = 'blue'
                        @input="validatePrice"
                        :error-messages="priceErrorMessages"
                        variant="outlined"
                      ></v-text-field>
                    </v-col>
                  </v-row>
              </div> -->
              </v-container>
            </v-card-text>
              <v-card-actions center  v-if="$isRelianceClient()">
              <v-spacer></v-spacer>
              <v-btn color="primary" class="mb-3 text-none" variant="outlined" @click="debitnotesubmit">Yes</v-btn>
              <v-btn color="primary" class="mb-3 text-none" variant="flat" @click="writeoffpopup = false">No</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>          
              <v-card-actions center v-else>
              <v-spacer></v-spacer>
              <v-btn
                variant="outlined"
                size="small"
                color="primary"
                class="cancel-color mb-3 text-none"
                @click="closeeriteoff"
                >Cancel</v-btn
              >
              <v-btn
                size="small"
                variant="flat"
                :color="submitButtonDisabled ? '' : 'primary'"
                class="mb-3 text-none"
                :disabled="!remarks"
                @click="debitnotesubmit"
                >Submit</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-row>
    <!-- Update Asignees -->
    <v-dialog v-model="assigneesdetails" persistent max-width="400px">
      <v-card class="v-card-100">
        <v-card-title class="d-flex align-center">
          <span>Updates Assignees</span>
          <v-spacer></v-spacer>
          <v-btn variant="solo" icon @click="assigneesdetails = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider :thickness="4" class="m-0" />
        <v-form>
          <v-card-text>
            <v-container>
              <v-row justify="center">
                <v-col cols="12">
                  <v-combobox
                    v-model="add_assignees"
                    :items="filteredAssignees"
                    item-title="full_name"
                    item-value="full_name"
                    label="Add Assignees"
                    multiple
                    variant="outlined"
                    @update:modelValue="handleAutocompleteInput('add_assignees')"
                    @keyup="searchItems($event)"
                    ref="assigneesearch"
                  ></v-combobox>
                  <p
                    v-for="(item, index) in assigneeselectitems"
                    :key="index"
                    class="addeditems"
                  >
                    {{ item.full_name }}
                    <v-btn
                      icon
                      @click="removeSelectedItem('add_assignees', index)"
                      class="closeitems"
                    >
                      <v-icon style="margin-top:-3px; font-size:16px">mdi-close</v-icon>
                    </v-btn>
                  </p>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-form>
        <v-card-actions center>
          <v-spacer></v-spacer>
          <v-btn size="small" variant="outlined" color="primary" class="cancel-color mb-3 text-none" @click="closeassigneepopup">Cancel</v-btn>
          <v-btn size="small" color="primary" variant="flat" class="mb-3 text-none" @click="updateassigneessubmit" :disabled="!this.assigneeselectitems.length > 0">Confirm</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Change Status -->
    <v-dialog v-model="change_status" persistent max-width="370px">
      <v-card class="v-card-100">
        <v-card-title class="d-flex align-center">
          <span>Change Status</span>
          <v-spacer></v-spacer>
          <v-btn variant="solo" icon @click="change_status = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider :thickness="4" class="m-0" />
        <v-form>
          <v-card-text>
            <v-container>
              <v-radio-group v-model="selected_status" row inline>
                <v-radio label="Closed" value="completed" class="mr-12 radio-styles" ></v-radio>
                <v-radio label="Re-Open" value="in_progress" class="ml-12 radio-styles"></v-radio>
              </v-radio-group>
            </v-container>
          </v-card-text>
        </v-form>
        <v-card-actions center>
          <v-spacer></v-spacer>
          <v-btn variant="outlined" small color="primary" class="cancel-color mb-3 text-none" @click="change_status = false" >Cancel</v-btn >
          <v-btn color="primary" variant="flat" small class="mb-3 text-none" @click="updateStatus(selected_status)" :disabled="!selected_status" >Confirm</v-btn >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

     <!-- update sub location popup -->
     <v-dialog v-model="update_subloc_popup" persistent max-width="370px">
      <v-card class="v-card-100">
        <v-card class="v-card-100 custom-shadow ma-0">
            <v-card-title class="pa-0">              
                <v-row class="ma-1">
                  <span class="font-weight-bold">Update Sub-Locationp</span>
                  <v-spacer></v-spacer>
                    <v-icon @click="update_subloc_popup = false">mdi-close</v-icon>
                </v-row>              
            </v-card-title>
            </v-card>
        <v-form>
          <v-card-text>
            <v-container>
              <v-combobox v-model="selected_sub_loc" :items="update_sub_loc_items" item-title="code" item-value="id" label="Update Sub-Location" variant="outlined"></v-combobox>
            </v-container>
          </v-card-text>
        </v-form>
        <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn variant="outlined" small color="primary" class="cancel-color mb-3 text-none" @click="update_subloc_popup = false">Cancel</v-btn>
            <v-btn color="primary" variant="flat" small class="mb-3 text-none" :disabled="number > 0 || !selected_sub_loc" @click="submitUpdateSubLocation">Confirm</v-btn>
            <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- update sub location popup -->
    <v-dialog v-model="updateSubLocationPopup" persistent max-width="370px">
      <v-card class="v-card-100">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Update Sub Location</span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="updateSubLocationPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
        </v-card>
        <v-form>
          <v-card-text>
            <v-container>
              <v-combobox v-model="update_Sub_location" color="blue" :items="update_Sub_locationItems" item-title="code" item-value="code" label="Update" variant="outlined"></v-combobox>
            </v-container>
          </v-card-text>
        </v-form>
        <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn variant="outlined" size="small" color="primary" class="cancel-color mb-3 text-none" @click="updateSubLocationPopup = false">Cancel</v-btn>
            <v-btn :color="number > 0 || !update_Sub_location ? '' : 'primary'" size="small" class="mb-3 text-none" :disabled="number > 0 || !update_Sub_location"  variant='flat' @click="submitSubLocation">Submit</v-btn>
            <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- data detail popup  -->
    <v-row justify="center">
      <v-dialog
        v-model="datadetailpopupdisposition"
        persistent
        max-width="700px"
      >
        <v-card class="v-card-100">
          <v-card class="v-card-100">
          <v-card-title>
            <v-row class="ma-1 mt-0">
            <span>Inventory Status: {{ select_id }}</span>
            <v-spacer></v-spacer>
            <!-- <v-btn variant="solo" icon > -->
              <v-icon @click="datadetailpopupdisposition = false">mdi-close</v-icon>
            <!-- </v-btn> -->
             </v-row>
          </v-card-title>
        </v-card>
          <v-divider :thickness="4" class="m-0" />
          <v-card-text class="p-0">
            <v-container>
              <div>
                <v-row>
                  <!-- <v-col class="pr-0">
                    <span class="status-items">
                      Total Inventory: {{ total_inventories > 0 ? total_inventories : 'NA' }}
                    </span>
                  </v-col> -->
                  <v-col class="pr-0">
                    <span class="status-items">
                      Scanned Inventory:  {{ scanned_items > 0 ? scanned_items : 'NA' }}
                    </span>
                  </v-col>
                  <v-col class="pr-0">
                    <span class="status-items">
                      Short Inventory:  {{ short_count > 0 ? short_count : 'NA' }}
                    </span>
                  </v-col>
                  <v-col class="pr-0">
                    <span class="status-items">
                      Excess Inventory: {{ short_excess_count > 0 ? short_excess_count : 'NA' }}
                    </span>
                  </v-col>
                </v-row>
                <v-data-table hover
                  density="compact"
                  :search="search"
                  v-model="selected"
                  disable-pagination
                  :hide-default-footer="true"
                  :headers="item_headers"
                  :items="details_data"
                  fixed-header
                  height="100%"
                  :loading="loading"
                  :items-per-page="pageSize"
                  loading-text="Loading Data... Please wait"
                >
                <template #bottom></template>
                </v-data-table>
                <!-- <v-row class="ml-2 pb-0">
                  <v-col cols="4" sm="3" class="PaddingItemPerPage">
                    <v-select
                      v-model="popuppageSize"
                      :items="itemspageSizes"
                      label="Items per page"
                      @update:modelValue="popupPageSizeChange"
                    ></v-select>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="12" sm="9" class="PaddingItemPerPage">
                    <v-pagination density="comfortable" elevation="2"
                      v-model="popuppage"
                      :length="popuptotalPages"
                      total-visible="7"
                      next-icon="mdi-menu-right"
                      prev-icon="mdi-menu-left"
                      active-color="bg-primary" 
                      @update:modelValue="popupPageChange"
                    ></v-pagination>
                  </v-col>
                </v-row>
              </div> -->
              <v-row class="ml-2 pb-0">
                  <v-col cols="4" sm="3" class="PaddingItemPerPage">
                    <v-select v-model="popuppageSize" :items="itemspageSizes" label="Items per page" @change="popupPageSizeChange"></v-select>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="12" sm="9" class="PaddingItemPerPage">
                    <v-pagination v-model="popuppage" :length="popuptotalPages" total-visible="7" next-icon="mdi-menu-right" prev-icon="mdi-menu-left" @input="popupPageChange"></v-pagination>
                  </v-col>
                </v-row>
              </div>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <v-dialog v-model="confirmationModelDelete" persistent max-width="450px">
          <v-card class="v-card-100">
            <v-card-title>
              <v-row class="my-1">
              <span>Confirmation</span>
              <v-spacer></v-spacer>  
              <!-- <v-btn icon @click="confirmationModelDelete = false"> -->
                  <v-icon @click="confirmationModelDelete = false">mdi-close</v-icon>
              <!-- </v-btn>           -->
            </v-row>
            </v-card-title>
          <v-card-text class="text-center pt-6">
              <span> {{ accessMessage }} </span>
          </v-card-text>  
          <v-card-actions center>
              <v-spacer></v-spacer>
              <v-btn small color="primary" variant="flat" class="text-none" @click="confirmedFunc()">Confirm</v-btn>
              <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    <!-- filter data popup -->
    <v-dialog content-class="filter-repair" v-model="filterDetails" persistent :max-width=" active_tab === 'Request Tracker' ? '400px' : active_tab === 'Item Issue' ? '1080px' : '600px' " >
      <v-card class="filter_ui">
        <v-card-actions>
          <!-- Request tracker fields -->
          <v-row>
            <v-col v-if="active_tab === 'Request Tracker'">
              <v-combobox v-model="status_filter" :items="filter_status" item-title="name" item-value="id" label="Status" color="blue" variant="outlined" ></v-combobox>
            </v-col>
              <!-- item issue tab filters -->
            <v-col v-if="active_tab === 'Item Issue'">
              <v-combobox v-model="locationAs" :items="locationAs_filter" item-title="location" item-value="location" color = 'blue' prepend-inner-icon="mdi-magnify" label="Location As Per System" variant="outlined" class="ma-2" loading="loading"> </v-combobox>
            </v-col>
            <v-col v-if="active_tab === 'Item Issue'">
              <v-combobox v-model="sort_items" :items="sort_filter" item-title="name" item-value="id" prepend-inner-icon="mdi-magnify" label="Inventory Status" color = 'blue' variant="outlined" class="ma-2" > </v-combobox>
            </v-col>
            <v-col v-if="active_tab === 'Item Issue'">
              <v-combobox v-model="excess" :items="excess_filter" item-title="name" item-value="id" color = 'blue' prepend-inner-icon="mdi-magnify" label="Status" variant="outlined" class="ma-2" > </v-combobox>
            </v-col>
          </v-row>
        </v-card-actions>
        <v-card-actions class="margin-10">
          <v-spacer></v-spacer>
          <v-btn size="small" variant="outlined" class="text-none" color="normal" @click="filterDetails = false" >Cancel</v-btn >
          <v-btn size="small" variant="flat" class="text-none" color="primary" @click="ApplyFilterFunc" >Apply Filter(s)</v-btn >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Item Issue tab popup end-->
    <!-- Tabs -->
    <v-card class="v-card-100 mt-6">
      <v-tabs color="primary" v-model="selected_tab">
        <v-tab
          ripple
          @click="loadData(tab, 'tab_clicked')"
          style="text-transform: none !important; text-decoration: none"
          v-for="(tab, index) in tabs"
          :key="index"
          class="component-tab-heading tab-color"
        >
          {{ tab }}
        </v-tab>
      </v-tabs>
    </v-card>

    <!-- Search, Action Buttons, Filter -->
    <v-card-title class="action-style pb-1">
    <v-row class="ma-1">
      <!-- Search Fields -->
      <v-row>
        <v-col cols="8" sm="8" class="pb-0">
          <v-text-field
            color="primary"
            prepend-inner-icon="mdi-magnify"
            v-model="search_tag"
            v-no-edge-space
            label="Search"
            class="search_style mt-2"
            variant="outlined"
            v-on:keyup.enter="loadData(active_tab)"
          ></v-text-field>
        </v-col>
      </v-row>

      <!-- Action Buttons -->
      <v-card-actions style="margin-bottom: 10px;" v-if="active_tab == 'Request Tracker'  && isActionAllowed(role)">
      <v-btn class="mr-2 pt-0 text-none" size="x-large" variant="flat" color="primary" @click="navigateToFileUpload">Uploaded List</v-btn>
          <v-btn class="mr-2 pt-0 text-none" size="x-large" variant="flat" color="primary" :disabled="(this.selected.length > 0)" @click="createrequest">Create Request</v-btn>
          <v-btn class="mr-2 pt-0 text-none" size="x-large" variant="flat" color="primary" :disabled="isUpdateButtonDisabled()" @click="updateassignees">Update Assignees</v-btn>
          <v-btn class="mr-2 pt-0 text-none" size="x-large" variant="flat" color="primary" :disabled="isUpdateButtonDisabled()" @click="deleteRequest">Delete</v-btn>
          <v-btn class="mr-2 text-none" size="x-large" variant="flat" color="primary" :disabled="isUpdateButtonDisabledRestart()" @click="restartRequest">Restart Request</v-btn>
          <!-- <v-btn class="mr-2 text-none" size="x-large" variant="flat"  color="primary" :disabled="statusDisabled()" @click="changeStatus">Change Status</v-btn> -->
      </v-card-actions>
      <v-card-actions style="margin-bottom: 10px;" v-if="active_tab == 'Item Issue'">
        <v-btn class="mr-2 pt-0  text-none" size="x-large" variant="flat" color="primary" :disabled="updateSubLocationDisb()" @click="open_update_sub_location">Update Sub-Location</v-btn>
          <v-btn class="mr-2 pt-0 text-none" size="x-large" variant="flat" color="primary" :disabled="writeOff()" @click="writeoff" value="write off">Write Off</v-btn>
          <v-btn class="mr-2 pt-0 text-none" size="x-large" variant="flat" color="primary" :disabled="ExcessCorrect()" @click="submitSubLocation">Correct Excess / Short</v-btn>
          <!-- <v-btn class="mr-2 pt-0 text-none" size="x-large" variant="flat" :color="ExcessCorrect() ? '' : 'primary'" :disabled="ExcessCorrect()" @click="correctexcess">Correct Excess / Short</v-btn> -->
          <v-btn class="mr-2 pt-0 text-none" size="x-large" variant="flat" color="primary" :disabled="disabledButton()" @click="writeon">Write On</v-btn>
      </v-card-actions>
      <!-- <v-card-actions style="margin-bottom: 10px;" v-if="active_tab == 'Item Issue' && isActionAllowed(role) && (role === 'admin')">
          <v-btn class="mr-2 pt-0 text-none" size="x-large" variant="flat" color="primary" :disabled="selected.length == 0" @click="approveItems">Approve</v-btn>
          <v-btn class="mr-2 pt-0 text-none" size="x-large" variant="flat" color="primary" :disabled="selected.length == 0" @click="rejectItems">Reject</v-btn>
      </v-card-actions> -->

      <!-- Filter -->
      <!-- <v-expansion-panels class="custom-control_outlined m-0 pt-2" style="height: 52px" ref="filterPopupRef" >
        <v-expansion-panel variant="outlined" @click="filterListOfButtons">
          <v-expansion-panel-title>
            Filter
          </v-expansion-panel-title>
        </v-expansion-panel>
      </v-expansion-panels> -->
      <v-expansion-panels class="custom-control_outlined  m-0 pt-2" ref="filterPopupRef" readonly
            style="max-width: 300px; margin-bottom: 28px; height: 52px;">
            <v-expansion-panel variant="outlined" @click="filterListOfButtons">
              <v-expansion-panel-title>Filter
              </v-expansion-panel-title>
            </v-expansion-panel>
          </v-expansion-panels>
      </v-row>
    </v-card-title>

    <!-- Data Table -->
    <v-layout column>
      <v-col cols="12" style="overflow: auto" class="p-0">
        <v-data-table hover
          density="compact"
          :search="search"
          v-model="selected"
          show-select
          disable-pagination
          :hide-default-footer="true"
          :headers="headers"
          :items="table_data"
          fixed-header
          height="100%"
          :loading="loading"
          :items-per-page="pageSize"
          loading-text="Loading Data... Please wait"
          class="elevation-1"
          return-object
        >
        <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers" :key="header.key">
              <span v-if="header.key == 'request_id' && active_tab == 'Request Tracker'">
                <span v-if="item.status === 'completed'">
                <a href="#" @click.prevent="linkPopupInReqTracker(item)" style="text-decoration: underline !important; color: #1976d2 !important; cursor: pointer !important;">{{ item.request_id }}</a>
              </span> 
              <span v-else>
              {{ item.request_id }}
            </span>
            </span>
            <span v-else-if="header.key == 'created_at'">
              {{ formatTimestamp(item.created_at) }}
            </span>
            <span v-else-if="header.key == 'assignees_hash'">
              <span v-if="item.assignees_hash">
              {{ Object.values(item.assignees_hash).join(", ") }}
            </span>
            <span v-else> Na </span>
            </span>
            <span v-else-if="header.key == 'status'">
              {{ formatStatus(item.status) }}
            </span>
            <span v-else-if="header.key == 'inventory_status'">
              {{ formatinventory(item.inventory_status) }}
            </span>
            <span v-else-if="header.key == 'system_sub_location'">
              <span>{{ item.system_sub_location ? item.system_sub_location : "N/A" }}</span>
            </span>
              <span v-else-if="header.key !== 'images' && item[header.key]">
                <span v-tooltip="item[header.key]">
                  {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + '...' : item[header.key] }}
                </span>
              </span>
              <span v-else>-</span>
            </template>

          <!-- <template
            v-if="active_tab == 'Request Tracker'"
            #[`item.request_id`]="{ item }"
          >
            <span v-if="item.status === 'completed'">
              <a
                @click="linkPopupInReqTracker(item)"
                style="color: #1976d2"
                class="cursor-pointer"
              >
                <u> {{ item.request_id }}</u>
              </a>
            </span>
            <span v-else>
              {{ item.request_id }}
            </span>
          </template> -->
          <!-- <template #[`item.created_at`]="{ item }">
            {{ formatTimestamp(item.created_at) }}
          </template> -->
          <!-- <template #[`item.assignees_hash`]="{ item }">
            <span v-if="item.assignees_hash">
              {{ Object.values(item.assignees_hash).join(", ") }}
            </span>
            <span v-else> Na </span>
          </template>
          <template #[`item.status`]="{ item }">
            {{ formatStatus(item.status) }}
          </template>
          <template #[`item.inventory_status`]="{ item }">
            {{ formatinventory(item.inventory_status) }}
          </template> -->
          <template #bottom></template>
        </v-data-table>
      </v-col>
    </v-layout>
    <!-- pagination display -->
    <PaginationComponent
                    :pageSize="pageSize"
                    :pageSizes="pageSizes"
                    :totalCount="totalCount"
                    :selected="selected"
                    :page="page"
                    :totalPages="totalPages"
                    @update:pageSize="handlePageSizeChange"
                    @update:page="handlePageChange"
                    class="mt-2 mb-0"
                />
  </v-card>
</template>
<script>
import HeaderComponent from "./../../../../commoncomponents/HeaderComponent";
import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
import { isOnlyViewAction } from '@/backend/axios/moduleAccess'

export default {
    components:{
        HeaderComponent,
    },
    data(){
        return{
            headerText:"Physical Inspection",
            tabs:[
                "Request Tracker",
                "Item Issue"
            ],
            active_tab:"Request Tracker",
            active_tab1_action_btn:'CREATE REQUEST',
            active_tab2_action_btn:'WRITE OFF',
            selected:[],
            table_data: [],
            headers:[
              { title: "Request ID", align: "start", sortable: false, key:"request_id"},
              { title: "Creation Date", key: "creation_date" },
              { title: "Status", key: "status" },
              { title: "Assignees", key: "assignees" },
            ],
            item_headers:[
              { title: "Request ID", align: "start", sortable: false, key:"request_id"},
              { title: "Creation Date", key: "creation_date" },
            ],
            details_data:[],
            dialogDetails: false,
            selectedOption: 'all_inventory',
            loading: true,
            writeoffpopup: false,
            showDebitNote: false,
            showWithoutDebitNote: false,
            assigneesdetails: false,
            change_status: false,
            select_location: [],
            filterDetails: false,
            vendor_code: [],
            vendor_data:'',
            debit_amount: null,
            add_assignees: [],
            ategory_select: [],
            search_id_names_select:[],
            closed_value: [],
            selected_tab : 0,
            location_items:[],
            successpopup: false,
            row:[],
            filteredAssignees: [],
            in_progress_value:[],
            search_id_names_items:[],
            status_filter: [],
            delivery_location_search:[],
            category:[],
            category_filter:'',
            brand_filter:'',
            locationAs:[],
            locationAs_filter:'',
            brand:[],
            excess:[],
            number:0,
            excess_filter:[
              {
                "name":"Pending For Approval",
                "id": "pending_for_approval"
              },
              {
                "name":"Pending For Action",
                "id": "pending_for_action"
              }
            ],
            sort_items:[],
            sort_filter:[{
                "name":"Excess",
                "id": "excess"
              },
              {
                "name":"Short",
                "id": "short"
              },
            ],
            selectedBrandIds:[],
            selectedCategoryIds:[],
            selectedArticleIds:[],
            selectedSearchIds:[],
            distribution_id:null,
            successmessage:'',
            search_tag: '',
            search:'',
            showSelectedItems: false,
            short_excess_count:[],
            datadetailpopupdisposition:false,
            assignees_assigned: [],
            assignee_details:[],
            filter_status: [
              {
                "name":"In Progress",
                "id": "in_progress"
              },
              {
                "name":"Closed",
                "id": "completed"
              },
              {
                "name":"Pending",
                "id": "pending"
              }
            ],
            selected_status: "completed",
            select_id:'',
            priceErrorMessages:'',
            page: 1,
            totalPages: [],
            totalCount: '',
            pageSize: defaultPageSize,
            pageSizes: defaultPageSizes,
            item:'',
            popuppage:1,
            popuppageSize: 25,
            itemspageSizes:[25,50,100],
            popuptotalPages:[],
            alert: false,
            alert_message:'',
            alert_type:'',
            itemStore:'',
            selectednameItems : [],
            assigneeselectitems:[],
            sub_location_id: [],
            sub_location_id_items: [],
            selectedLocationId: [],
            updateSubLocationPopup : false,
            update_Sub_location: [],
            update_Sub_locationItems : [],
            isPartialOptionDisabled: true,
            isFilteringPage: false,
            filterPageNo : 1,
            scanned_items : '',
            short_count : '',
            total_inventories: '',
            role : '',
            remarks:'',
            confirmationModelDelete : false,
            accessMessage : '',
            acceptOrReject : '',
            successmessage : '',
            update_subloc_popup : false,
            update_sub_loc_items : [],
            selected_sub_loc : null,
            distribution_cent_id:'',
            organization_name:'',
            inspection_file: null

        }
    },

    async created(){
      const tab = this.$store.state.active_tab
      this.role = this.$store.state.currentUser.roles[0]
      this.organization_name = this.$store.state.organization_name
      if(this.tabs.includes(tab)){
        this.loadData(tab);
        this.selected_tab = this.tabs.indexOf(tab)
      } else {
        this.loadData('Request Tracker');
        this.selected_tab = 0
      }
      this.scrollToTop();
    },
    watch : {
      search_id_names_select(newValue){
          if (newValue && newValue.length > 0) {
            this.$nextTick(() => {
              this.$refs.searchClear.internalSearch = '';
            });
          }
        },
        sub_location_id(newValue){
          if (newValue && newValue.length > 0) {
            this.$nextTick(() => {
              this.$refs.searchLocationIdClear.internalSearch = '';
            });
          }
        },
        vendor_code(newValue){
          if (newValue && newValue.length > 0) {
            this.$nextTick(() => {
              this.$refs.vendorsearchClear.internalSearch = '';
            });
          }
        },
        add_assignees(newValue){
          if (newValue && newValue.length > 0) {
            this.$nextTick(() => {
              this.$refs.assigneesearch.internalSearch = '';
            });
          }
        },
    },
    computed: {
      // selectednameItems() {
      //   return this.search_id_names_select;
      // },
      submitButtonDisabled() {
        if (!this.showDebitNote && !this.showWithoutDebitNote) {
          return true;
        }
        if (this.showDebitNote && (!this.vendor_code || !this.debit_amount)) {
          return true;
        }
        return false;
      },
      isSubmitDisabled() {
        if (this.selectedOption === 'partial') {
          if(this.selectedLocationId.length > 0)
          return !this.selectedLocationId.length > 0 || !this.select_location || !this.selectednameItems.length > 0
          else
          return !this.inspection_file || !this.selectednameItems.length > 0

        }
        if (this.selectedOption === 'all_inventory' && (!this.select_location || !this.selectednameItems.length > 0)) {
          return true;
        }
        return false;
      },
      formattedDebitAmount : {
        get() {
          return (this.debit_amount).toLocaleString('en-IN') ;
        },
        set(value) {
          const numericValue = Number(value.replace(/[^0-9.-]+/g, ''));
          this.debit_amount = Math.max(parseFloat(numericValue), '');
        }
      }
    },
    methods:{
        isActionAllowed(){
          return !isOnlyViewAction(this.role, 'Cycle Count')
        },
        loadData(tab, tab_action){
            if (tab_action) {
              this.search_tag = ''
            }
            this.selected = []
            this.active_tab = tab
            this.table_data = []
            this.page = 1
            this.totalPages = 1
            this.filterPageNo = 1
            this.isFilteringPage = false
            this.$store.commit('setActiveTab',{
              'active_tab' : tab
            })
            this.loading = true;
            if(tab == 'Request Tracker'){
                (this.headers = [
                    { title: "Request ID",  key:"request_id"},
                    { title: "Creation Date", key: "created_at" },
                    { title: "Status", key: "status" },
                    { title: "Assignees", key: "assignees_hash" },
                ]);
                this.requestData();
            }
            if(tab == 'Item Issue'){
                (this.headers = [
                    { title: "Request ID", key: "request_id" },
                    { title: "Scanned Sub-Location ID", key: "sub_location_id"},
                    { title: "System Sub-Location ID", key: "system_sub_location"},
                    { title: "Tag ID", align: "start", sortable: false, key:"tag_number"},
                    { title: "Article ID", align: "start", sortable: false, key:"article_id"},
                    { title: "Article Description", align: "start", sortable: false, key:"article_description"},
                    { title: "Excess/Short", align: "start", sortable: false, key:"inventory_status"},
                    { title: "Approval Status", key: "status" },
                ]);
                this.itemissues();
               
            }
        },
        scrollToTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        },
        requestData(){
          this.loading = true;
          const searchArray = [];
          if(this.search_tag != ''){
            const parts = this.search_tag.split(',');
            for(let i=0;i<parts.length;i++){
                searchArray.push(parts[i]);
              }
          }
          const params = this.getRequestParams(
            this.page,
            this.pageSize
          );
          this.$httpSecured
            .get('/api/v1/physical_inspections', {
              params: 
                  { 
                    search: searchArray, 
                    page: params['page'], 
                    per_page: params['size'],
                  }
              })
            .then(response => {
              if (response.data) {
                this.table_data = response.data.physical_inspections;
                this.totalPages = response.data.meta.total_pages;
                this.totalCount = response.data.meta.total_count;
                this.makeLoadingFalse();
                this.loading = false
              } else {
                this.showAlert("error", "No Data Found");
                this.loading = false;
              }
            })
            .catch(error => {
              this.showAlert("error", error.response.data.message);
              this.loading = false;
            });
        },
       itemissues(){
          this.loading = true;
          const searchArray = [];
          if(this.search_tag != ''){
            const parts = this.search_tag.split(',');
            for(let i=0;i<parts.length;i++){
                searchArray.push(parts[i]);
              }
          }
          const params = this.getRequestParams(
            this.page,
            this.pageSize
          );
          let endpoint = '/api/v1/issue_inventories';
             
          this.$httpSecured
            .get(endpoint,{
              params: 
                  { 
                    search: searchArray, 
                    page: params['page'], 
                    per_page: params['size'],
                  }
              })
            .then(response => {
              if (response.data) {
                this.table_data = response.data.issue_inventories;
                this.totalPages = response.data.meta.total_pages;
                this.totalCount = response.data.meta.total_count;
                this.makeLoadingFalse();
                this.loading = false
              } else {
                this.showAlert("error", "No Data Found");
                this.loading = false;
              }
            })
            .catch(error => {
              this.showAlert("error", error.response.data.message);
              this.loading = false;
            });
        },
        formatStatus(status) {
          if (status === "in_progress") {
            return "In Progress";
          } else if (status === "completed") {
            return "Completed";
          } else if (status === "pending") {
            return "Pending";
          } else if (status === "pending_for_approval") {
            return "Pending For Approval";
          } else if (status === "pending_for_action") {
            return "Pending For Action";
          } else {
            return status;
          }
        },
        formatinventory(inventory_status){
          if (inventory_status === "short") {
            return "Short";
          } else if (inventory_status === "excess") {
            return "Excess";
          } else {
            return inventory_status;
          }
        },
        linkPopupInReqTracker(item) {
          this.itemStore = item
          this.datadetailpopupdisposition = true;
          const selectedIds =  item.id
          this.select_id = item.request_id;
          this.loading = true;
          const params = this.getRequestParams(
            this.popuppage,
            this.popuppageSize
          );
          
          this.$httpSecured
            .get(`/api/v1/physical_inspections/${selectedIds}/issue_items`, {
              params :{ 
                    page: params['page'], 
                    per_page: params['size'],
                  }
            })
            .then(response => {
              if (response.data) {
                this.item_headers = [
                  { title: "Tag Id", align: "start", sortable: false, key: "tag_number" },
                  { title: "Status", key: "inventory_status" },
                ];
                this.details_data = response.data.issue_items;
                this.short_excess_count = response.data.excess_items_count;
                this.scanned_items = response.data.scan_items_count;
                this.short_count = response.data.short_items_count
                this.total_inventories = response.data.issue_items_count
                this.popuptotalPages = response.data.meta.total_pages;
                this.loading = false;
                
              } else {
                this.showAlert("error", "No Data Found");
                this.loading = false;
              }
            })
            .catch(error => {
              this.showAlert("error", "Something went wrong from Network: " + error);
              this.loading = false;
            });
        },
        assigneeStatus(){
          this.selected.item.length = 0;
          this.selected.item.status = 'pending';
        },
        formatTimestamp(timestamp) {
          const date = new Date(timestamp);
          const day = date.getDate().toString().padStart(2, '0');
          const month = (date.getMonth() + 1).toString().padStart(2, '0');
          const year = date.getFullYear();
          let hour = date.getHours();
          const minute = date.getMinutes();
          const amPM = hour >= 12 ? 'PM' : 'AM';
          hour = hour % 12 || 12;
          const formattedTime = `${hour}:${minute.toString().padStart(2, '0')} ${amPM}`;
          return `${day}/${month}/${year}`;
        },
        // create request 
        createrequest() {
          this.select_location = null;
          this.search_id_names_select = null;
          this.sub_location_id = null;
          this.number = 0;
          this.dialogDetails = true;
          this.inspection_file = null;
          this.selectedOption = 'all_inventory';
          this.isPartialOptionDisabled = true,
          this.$httpSecured
            .get('/api/v1/distribution_centers')
            .then(response => {
              this.location_items = response.data.distribution_centers;
            })
            .catch(error => {
              console.error("Error fetching brand data:", error);
            });
          // this.$httpSecured
          //   .get('/api/v1/physical_inspections/assignees')
          //   .then(response => {
          //     this.search_id_names_items = response.data.users;
          //   })
          //   .catch(error => {
          //     console.error("Error fetching disposition data:", error);
          //   });
        },
        subLocationChange(){
          const subLocationId = this.select_location.id
          this.distribution_cent_id = this.select_location.id
          const params = {
            distribution_center_id : subLocationId
          }
          this.$httpSecured
            .get('/api/v1/physical_inspections/get_sub_locations', {params : params})
            .then(response => {
              this.getAssigne();
              this.sub_location_id_items = response.data.sub_locations;
              this.isPartialOptionDisabled = !this.sub_location_id_items || this.sub_location_id_items.length === 0;
              this.selectedLocationId = [];

            })
            .catch(error => {
              console.error("Error fetching brand data:", error);
            });
        },
        getAssigne(){
          const params = {
              "distribution_center_id" : this.distribution_cent_id
            }
          this.$httpSecured
              .get('/api/v1/physical_inspections/assignees', {params : params})
              .then(response => {
                this.search_id_names_items = response.data.users;
              })
              .catch(error => {
                console.error("Error fetching disposition data:", error);
              });
        },
        requestSubmission() {
          this.number++;
          const distribution_id = this.select_location.id;
          const locationIdArray = this.selectedLocationId.map(item => item.id);
          const locationId = locationIdArray.length > 0 ? locationIdArray : null;
          const assigneesObject = {};
          this.selectednameItems.forEach((item) => {
            assigneesObject[item.id] = item.full_name;
          });
          const physicalInspectionData = {
            physical_inspection: {
              distribution_center_id: distribution_id,
              inventory_type: this.selectedOption,
              assignees_hash: assigneesObject,
              sub_location_ids: locationId
            },
          };
          const formData = new FormData();
          formData.append("physical_inspection[distribution_center_id]", distribution_id);
          formData.append("physical_inspection[inventory_type]", this.selectedOption);

          Object.keys(assigneesObject || {})
            .filter(key => key !== undefined && key !== null && assigneesObject[key] !== undefined && assigneesObject[key] !== null)
            .forEach(key => {
              formData.append(`physical_inspection[assignees_hash][${key}]`, assigneesObject[key]);
            });
          if(locationId && locationId.length > 0){            
            locationId
              .filter(id => id !== undefined && id !== null && id !== "")
              .forEach(id => {
                formData.append("physical_inspection[sub_location_ids][]", id);
              });
          }

          if (this.inspection_file) {
            formData.append("file", this.inspection_file);
          }

          this.$httpSecured
            .post('/api/v1/physical_inspections', formData)
            .then((response) => {
              if (response.data) {
                this.successpopup = true;
                this.successmessage = response.data.message;
                this.select_location = null;
                this.search_id_names_select = '';
                this.sub_location_id = [];
                this.selectedLocationId = [];
                this.selectednameItems = [];
                this.selectedOption = 'all_inventory'
                this.loadData(this.active_tab);
              } else {
                this.showAlert('error', 'No Data Found');
              }
              this.loading = false;
            })
            .catch((error) => {
              this.$toast.error(error.response.data.error);
              this.loading = false;
            });
        },
        dialogDetailsClose(){
          this.dialogDetails = false;
          this.selectedOption = '';
          this.selectednameItems = [];
          this.selectedLocationId = [];
        },
        closeassigneepopup(){
          this.assigneesdetails = false;
          this.assigneeselectitems ='';
        },
        ApplyFilterFunc(){
          this.isFilteringPage = true
          const params = new URLSearchParams();
          
          params.append('page' , this.filterPageNo)
          params.append('per_page' ,this.pageSize)
          if (this.active_tab == "Request Tracker") {
            this.loading = true;
            const statusfield = this.status_filter ? this.status_filter.id : ''
            params.append('statuses', statusfield);
            this.$httpSecured
              .get('/api/v1/physical_inspections', { params })
              .then(response => {
                if (response.data) {
                  this.table_data = response.data.physical_inspections;
                  this.totalPages = response.data.meta.total_pages;
                  this.totalCount = response.data.meta.total_count;
                  this.filterDetails = false;
                  this.loading = false;
                  this.status_filter='';
                  this.selected = [];
                } else {
                  this.loading = false;
                  this.showAlert("error", "No Data Found");

                }
              })
              .catch(error => {
                this.showAlert("error", error.response.data.message);
                this.loading = false;
              });
            }else
            if (this.active_tab === "Item Issue") {
              this.loading = true;
              const sort_items_id = this.sort_items ? this.sort_items.id : '';
              const excess_id = this.excess ? this.excess.id : '';
              if (sort_items_id) {
                params.append('inventory_statuses', this.sort_items.id);
              }
              if (this.locationAs) {
                params.append('locations', this.locationAs);
              }
              if (excess_id) {
                params.append('statuses', this.excess.id);
              }
              this.$httpSecured
                .get('/api/v1/issue_inventories', { params })
                .then(response => {
                  if (response.data) {
                    this.table_data = response.data.issue_inventories;
                    this.totalPages = response.data.meta.total_pages;
                    this.totalCount = response.data.meta.total_count;
                    this.filterDetails = false;
                    this.loading = false;
                    this.selected = [];
                  } else {
                    this.loading = false;
                    this.showAlert("error", "No Data Found");
                  }
                })
                .catch(error => {
                  this.showAlert("error", error.response.data.message);
                  this.loading = false;
                });
            }
        },
        afterClickOkLoadData(){
          this.successpopup = false;
          this.assigneesdetails = false;
          this.change_status = false;
          this.dialogDetails = false;
          this.writeoffpopup = false;
          this.updateSubLocationPopup = false;
          this.selected = ''
          this.loadData(this.active_tab);
        },
        updateassignees() {
          this.assigneesdetails = true;
          this.distribution_cent_id = this.selected[0].distribution_center_id
          const params = {
            "distribution_center_id":this.distribution_cent_id
          }
          const selectedItem = this.selected.find(item => item.id);
          if (selectedItem && selectedItem.assignees_hash) {
            const assigneesHash = selectedItem.assignees_hash;
            this.assigneeselectitems = Object.keys(assigneesHash).map(item => ({ id: item, full_name: assigneesHash[item] }));
          } else {
            this.assigneeselectitems = [];
            this.add_assignees = [];
          }
          this.$httpSecured
          .get('/api/v1/physical_inspections/assignees', {params : params})
          .then(response => {
              if (response.data) {
                this.filteredAssignees = response.data.users;
              } else {
                this.showAlert("error", "No Data Found");
                this.loading = false;
              }
            })
            .catch(error => {
              this.showAlert("error", error.response.data.message);
              this.loading = false;
            });
        },
        updateassigneessubmit() {
          const assigneesObject = {};
          this.assigneeselectitems.forEach((item) => {
            assigneesObject[item.id] = item.full_name;
          });
          this.$httpSecured
            .post('/api/v1/physical_inspections/update_assignees', 
              {
                "id": this.selected.map(item => item.id),
                "assignees_hash": assigneesObject, 
              }
            )
            .then(response => {
              if (response.data) {
                this.successpopup = true;
                this.successmessage = response.data.message
                
              } else {
                this.showAlert("error", "No Data Found");
                this.loading = false;
              }
            })
            .catch(error => {
              this.showAlert("error", error.response.data.message);
              this.loading = false;
            });
        },
        isUpdateButtonDisabled() {
          return this.selected.length === 0 || this.selected.some(item => item.status !== "pending");
        },
        isUpdateButtonDisabledRestart() {
          return (
            this.selected.length === 0 ||
            !this.selected.every(item => item.status === "completed" || item.status === "in_progress")
          );
        },
        statusDisabled(){
          return this.selected.length !== 1 || this.selected.some(item => item.status === "pending");
        },
        ExcessCorrect() {
          return ( this.selected.length !== 0);
        },
        updateSubLocationDisb(){
          return this.selected.length != 1 || this.selected[0].inventory_status !== "short"  || (this.selected[0].system_sub_location == 'Different Location') || (this.selected[0].system_sub_location == "" || this.selected[0].system_sub_location == "N/A")
        },
        writeOff(){
          return this.selected.length === 0 || this.selected.some(item => item.inventory_status !== "short" ) || this.selected.some(item => item.status === 'pending_for_approval')
        },
        disabledButton(){
          return this.selected.length === 0 || this.selected.some(item => item.inventory_status !== "excess") || this.selected.some(item => item.status === 'pending_for_approval')
        },
        requestscreencancel(){
          this.dialogDetails = false;
        },
        changeStatus(){
          this.change_status = true;
        },
        updateStatus(selected_status) {
          const request_id=this.selected.map(item => item.id).toString();
          if(selected_status === 'completed'){
            this.$httpSecured
            .post('/api/v1/physical_inspections/update_status', {
              "id": request_id,
              "status": 'completed',
            })
            .then(response => {
              if (response.data) {
                this.successpopup = true;
                this.successmessage = response.data.message;
              } else {
                this.showAlert("error", "No Data Found");
                this.loading = false;
              }
            })
            .catch(error => {
              this.showAlert("error", error.response.data.error);
              this.loading = false;
            });
          }else{
            this.$httpSecured
            .post('/api/v1/physical_inspections/reopen_request', {
              "id": request_id,
            })
            .then(response => {
              if (response.data) {
                this.successpopup = true;
                this.successmessage = response.data.message;
              } else {
                this.showAlert("error", "No Data Found");
                this.loading = false;
              }
            })
            .catch(error => {
              this.showAlert("error", error.response.data.error);
              this.loading = false;
            });
          }
        },
        writeoff() {
          this.writeoffpopup = true;
          this.vendor_code = null;
          this.debit_amount = '';
          this.$httpSecured
          .get('/api/v1/vendor_masters')
          .then(response => {
            this.vendor_data = response.data.vendor_masters.map(item => item.vendor_code);
          })
          .catch(error => {
            console.error("Error fetching disposition data:", error);
          });
        },
        handleCheckboxChange(checkboxName) {
            if (checkboxName === 'showDebitNote' && this.showDebitNote) {
                this.showWithoutDebitNote = false;
            } else if (checkboxName === 'showWithoutDebitNote' && this.showWithoutDebitNote) {
                this.showDebitNote = false;
            }
        },
        open_update_sub_location(){
          this.number = 0
          // this.update_sub_loc_items = [
          //   { name: `${this.selected[0].sub_location_id} (Scanned Sub-Location)`, id: this.selected[0].item_sub_location_id },
          //   { name: `${this.selected[0].system_sub_location} (System Sub-Location)`, id: this.selected[0].system_sub_location_id }
          // ]
          this.getSubLocationList();
          this.update_subloc_popup = true;
          this.selected_sub_loc = null;
        },
        getSubLocationList() {
          this.$httpSecured.get(`/api/v1/issue_inventories/sub_location_list?issue_inventory_id=${this.selected[0].id}`)
           .then(response => {
             if (response.data) {
               this.update_sub_loc_items = response.data.sub_locations;
             } else {
               this.showAlert("error", "No Data Found");
             }
           })
           .catch(error => {
             this.showAlert("error", error.response.data.error);
           });
        },
        submitUpdateSubLocation(){
          this.number++;
          const params = {
            'issue_inventory_id' : this.selected[0].id,
            'sub_location_id' : this.selected_sub_loc.id
          };
          this.$httpSecured.post('/api/v1/issue_inventories/update_sub_location', params)
            .then(response => {
              if (response.data) {
                this.update_subloc_popup = false
                this.successpopup = true;
                this.successmessage = response.data.message;
              } else {
                this.showAlert("error", "No Data Found");
              }
              this.number = 0;
              this.loading = false;
            })
            .catch(error => {
              this.number = 0;
              this.showAlert("error", error.response.data.error);
              this.loading = false;
            });
        },
        handleAutocompleteInput(fieldName) {
          if(fieldName == 'search_id_names_select'){
            this.selectednameItems.push(this.search_id_names_select[0]);
            this.search_id_names_items = this.search_id_names_items.filter(item => item !== this.search_id_names_select[0]);
            this.search_id_names_select = [];
            this.$refs.searchClear.internalSearch = '';
          } else if(fieldName == 'sub_location_id'){
            this.selectedLocationId.push(this.sub_location_id[0]);
            this.sub_location_id_items = this.sub_location_id_items.filter(item => item !== this.sub_location_id[0]);
            this.sub_location_id = [];
            this.$refs.searchLocationIdClear.internalSearch = '';
          } else if (fieldName === 'add_assignees' && this.add_assignees.length > 0) {
            const existingAssignee = this.add_assignees[0];
            if (!this.assigneeselectitems.some(item => item.id === existingAssignee.id)) {
              this.assigneeselectitems.push(existingAssignee);
            }
            this.filteredAssignees = this.filteredAssignees.filter(item => item.id !== existingAssignee.id);
            this.add_assignees = [];
            this.$refs.assigneesearch.internalSearch = '';
          }
          const computedPropertyName = `showSelected${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)}Items`;
          this[computedPropertyName] = this[fieldName].length > 0;
        },
        searchItems(event) {
          const searchTerm = event.target.value;
          const params = {
            "distribution_center_id" : this.distribution_cent_id,
            "search" : searchTerm
          }
          this.$httpSecured
          .get(`/api/v1/physical_inspections/assignees`, {params : params})
          .then(response => {
              this.search_id_names_items = response.data.users;
              this.search_id_names_items = this.search_id_names_items.filter( item => !this.selectednameItems.some( assignee => assignee == item));
              this.filteredAssignees = response.data.users;
            })
            .catch(error => {
              console.error("Error fetching assignees data:", error);
            });
        },
        searchVendor(event){
          const getVendor = event.target.value
          this.$httpSecured
          .get(`/api/v1/vendor_masters?search=${getVendor}`)
          .then(response => {
            this.vendor_data = response.data.vendor_masters;
          })
          .catch(error => {
            console.error("Error fetching disposition data:", error);
          });
        },
        removeSelectedItem(fieldName,index) {
          if(fieldName == 'search_id_names_select'){
            this.search_id_names_items.push(this.selectednameItems[index]);
            this.selectednameItems.splice(index,1);
          } if(fieldName == 'sub_location_id'){
            // this.search_id_names_items.push(this.selectedLocationId[index]);
            // this.selectedLocationId.splice(index,1);
            const removedItem = this.selectedLocationId.splice(index, 1)[0];
            this.sub_location_id_items.push(removedItem);

          }  else if(fieldName == 'add_assignees'){
            const removedItem = this.assigneeselectitems.splice(index, 1)[0];
            this.filteredAssignees.push(removedItem);
          }  
        },
        filterListOfButtons() {
          document.documentElement.style.setProperty('--dialog-ypos', (this.$refs.filterPopupRef.$el.getBoundingClientRect().top + 40).toString() + 'px');
          this.locationAs = null;
          this.sort_items = null;
          this.excess = null;
          this.status_filter=null;
          this.search_tag = '';
          this.filterDetails = true;
          this.loading = true;
            this.$httpSecured
            .get('/api/v1/physical_inspections')
            .then(response => {
              if (response.data) {
                // this.filter_status = response.data.physical_inspections;
              } else {
                this.showAlert("error", "No Data Found");
                this.loading = false;
              }
            })
            .catch(error => {
              this.showAlert("error", error.response.data.message);
              this.loading = false;
            });
            this.$httpSecured
            .get('/api/v1/issue_inventories/get_filter_locations')
            .then(response => {
              if (response.data) {
                this.locationAs_filter = response.data;
                this.loading = false
                // this.sort_filter = response.data.issue_inventories;
                // this.excess_filter = response.data.issue_inventories.map(item => item.status);
              } else {
                this.showAlert("error", "No Data Found");
                this.loading = false;
              }
            })
            .catch(error => {
              this.showAlert("error", error.response.data.message);
              this.loading = false;
            });
        },
        debitnotesubmit(){
          const selected_id = this.selected.map(item => item.id)
          // const dataToSendBase = {
          //   ids: selected_id,
          //   status: "Write Off",
          // };
          // let dataToSend;
          // if (this.showDebitNote && this.showWithoutDebitNote) {
          //   dataToSend = { ...dataToSendBase };
          // } else if (this.showDebitNote) {
          //   let vendorCodeArray;
          //   if (Array.isArray(this.vendor_code)) {
          //     vendorCodeArray = this.vendor_code.map(item => item.vendor_code);
          //   } else {
          //     vendorCodeArray = [this.vendor_code.vendor_code];
          //   }
          //   const vendorCode = vendorCodeArray.join(', ');
          //   dataToSend = {
          //     ids: selected_id,
          //     status: "Write Off",
          //     vendor_code: vendorCode,
          //     claim_amount: this.debit_amount,
          //   };
          // } else if (this.showWithoutDebitNote) {
          //   dataToSend = {
          //     ids: selected_id,
          //     status: "Write Off",
          //   };
          // } else {
          //   this.showAlert("error", "Please select at least one checkbox");
          //   return;
          // }

          this.$httpSecured
            .post('/api/v1/issue_inventories/update_status',
            {
                "ids": selected_id,
                "status": "Write Off",
                "remarks": this.remarks
              }
            )
            .then(response => {
              if (response.data) {
                this.writeoffpopup = false;
                this.successpopup = true;
                this.successmessage = response.data.message;
                this.vendor_code = [];
                this.debit_amount = '';
                this.showDebitNote = '';
                this.showWithoutDebitNote = '';
              } else {
                this.showAlert("error", "No Data Found");
              }
              this.loading = false;
            })
            .catch(error => {
              this.showAlert("error", error.response.data.message);
              this.loading = false;
            });
        },
        closeeriteoff(){
          this.writeoffpopup = false;
          this.showDebitNote = false;
          this.showWithoutDebitNote= false;
        },
        correctexcess(){
          this.update_Sub_location = null;
          const selected_ids = this.selected.map(item => item.distribution_center_id)
          const params = {
            distribution_center_id: selected_ids
          };
          this.$httpSecured
            .get('/api/v1/physical_inspections/get_sub_locations', {
              params: params
            })
            .then(response => {
              if (response.data) {
                this.update_Sub_locationItems = response.data.sub_locations;
                this.updateSubLocationPopup = true;
              } else {
                this.showAlert("error", "No Data Found");
              }
              this.loading = false;
            })
            .catch(error => {
              this.showAlert("error", error.response.data.message);
              this.loading = false;
            });
        },
        submitSubLocation() {
          this.number++;
          const selected_ids = this.table_data.map(item => item.id);
          const updateSubLocationId = this.update_Sub_location.id;
          const params = {
            ids: selected_ids
          };

          this.$httpSecured.post('/api/v1/issue_inventories/correct_excess', params)
            .then(response => {
              if (response.data) {
                this.successpopup = true;
                this.successmessage = response.data.message;
              } else {
                this.showAlert("error", "No Data Found");
              }
              this.number = 0;
              this.loading = false;
            })
            .catch(error => {
              this.number = 0;
              this.showAlert("error", error.response.data.message);
              this.loading = false;
            });
        },
        writeon(){
          const selected_ids = this.selected.map(item => item.id)
          const params = {
            status: 'Write on',
            ids: selected_ids
          }
          this.$httpSecured.post('/api/v1/issue_inventories/update_status',params)
            .then(response => {
              if (response.data) {
                this.successpopup = true;
                this.successmessage = response.data.message;
              } else {
                this.showAlert("error", "No Data Found");
              }
              this.loading = false;
            })
            .catch(error => {
              this.showAlert("error", error.response.data.message);
              this.loading = false;
            });
        },
        validatePrice() {
          const cleanedPrice = this.debit_amount.replace(/[^\d.]/g, '');
          if (
            !/^[1-9]\d*(\.\d{0,2})?$/.test(cleanedPrice) || 
            cleanedPrice !== this.debit_amount || 
            parseFloat(cleanedPrice) === 0.0 
          ) {
            this.priceErrorMessages = ['Please enter a valid amount greater than zero.'];
          } else {
            this.priceErrorMessages = [];
          }

          this.debit_amount = cleanedPrice;
        },
        // create request dropdown data getting
        makeLoadingFalse(){
          setTimeout(() => {
            this.loading = false;
            this.alert = false;
          }, 1500);
        },
        //  pagination params
        getRequestParams(page, pageSize, filterPageNo) {
          let params = {};
          if (page) {
            params["page"] = page;
          }
          if (pageSize) {
            params["size"] = pageSize;
          }
          if (filterPageNo) {
            params["filterPageNo"] = filterPageNo
          }
          return params;
        },
         // To handle the page change
        handlePageChange(value) {
            this.page = value;
            if(this.isFilteringPage){
              this.filterPageNo = value;
              this.ApplyFilterFunc()
              return;
            }
            if (this.active_tab == 'Request Tracker') {
                this.requestData();
            } else if (this.active_tab == 'Item Issue') {
                this.itemissues();
            }
        },

        //  To handle the page size change
        handlePageSizeChange(size) {
            this.pageSize = size;
            this.page = 1
            this.filterPageNo = 1;
            if(this.isFilteringPage){
              this.ApplyFilterFunc();
              return;
            }
            if (this.active_tab == 'Request Tracker') {
                this.requestData();
            } else if (this.active_tab == 'Item Issue') {
                this.itemissues();
            }
        },
        showAlert(alert_type, alert_message) {
          this.alert = true;
          this.alert_type = alert_type;
          this.alert_message = alert_message;
          this.makeLoadingFalse();
        },
        popupPageSizeChange (size){
          this.popuppageSize = size;
          this.popuppage = 1
          this.linkPopupInReqTracker(this.itemStore);
        },
        popupPageChange(value) {
            this.popuppage = value;
            this.linkPopupInReqTracker(this.itemStore);
        },
        deleteRequest() {
      const deleteId = this.selected.map(x => x.id).join(',')
      this.$httpSecured
        .delete("/api/v1/physical_inspections/delete_requests", { params: { ids: deleteId } })
        .then(response => {
          if (response.status == 200) {
            this.loadData(this.active_tab);
            this.selected = [];
            this.showAlert("success",response.data.message);
          } else {
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", error.response.data.error);
        });
      this.deleteSubLocationDialog = false
    },
    restartRequest() {
      const restartId = this.selected.map(x => x.id).join(',')
      this.$httpSecured
        .post("/api/v1/physical_inspections/reopen_request", 
          {  
            "ids": restartId  
          })
        .then(response => {
          if (response.status == 200) {
            this.loadData(this.active_tab);
            this.selected = [];
            this.showAlert("success",response.data.message);
          } else {
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", error.response.data.error);
        });
      this.deleteSubLocationDialog = false
    },
    approveItems(){
          this.confirmationModelDelete = true;
          this.acceptOrReject = "accepted";
          this.accessMessage = "Are you sure! You want Approve ?"
        },
    rejectItems(){
          this.confirmationModelDelete = true;
          this.acceptOrReject = "rejected";
          this.accessMessage = "Are you sure! You want Reject ?"
        },
    confirmedFunc(){
          const selectedId = this.selected.map(x => x.id);
          if(this.acceptOrReject == "accepted"){
              this.$httpSecured
              .post('/api/v1/issue_inventories/approve', { ids : selectedId })
              .then(response => {
                if (response.data) {
                  this.confirmationModelDelete = false;
                  this.showAlert("success", response.data.message);
                  this.loadData(this.active_tab);
                  this.selected = [];
                } else {
                this.showAlert("error", "No Data Found");
                }
              })
              .catch(error => {
                this.showAlert("error", error.response.data.error);
                this.loading = false;
              });
          }
          else if(this.acceptOrReject == "rejected"){
            this.$httpSecured
              .post('/api/v1/issue_inventories/reject', { ids : selectedId })
              .then(response => {
                if (response.data) {
                  this.confirmationModelDelete = false;
                  this.showAlert("success", response.data.message);
                  this.loadData(this.active_tab);
                  
                } else {
                  this.loading = false;
                  this.showAlert("error", "No Data Found");
                }
              })
              .catch(error => {
                this.showAlert("error", error.response.data.error);
                this.loading = false;
              });
          }
          this.acceptOrReject = '';
        },

        updateSelectedoption(){
          this.selectedLocationId = [];
        },
      handleFileUpload(event) {
        const fileType = this.inspection_file.type;
        if (fileType !== "text/csv") {
          this.$toast.error("Please upload a valid CSV file");
          this.inspection_file = null;
        }
      },
      navigateToFileUpload() {
        this.$store.commit("setLotIds", {
          lotIds: this.headerText,
          inventoryId: '',
          action:"first_tab"
        });
        this.$store.commit("config/ADD_HEADER", this.headerText);
        this.$router.push({ name: "LotFileuploadComm" });
      },
    downloadSampleFile(){
        console.log("downloadSampleFile");
        this.$httpSecured
          .get("/api/v1/physical_inspections/download_sample_file")
          .then(response => {
                    const link = document.createElement('a');
                    link.href = response.data.url; 
                    link.target = '_blank';
                    link.download = 'inventory.csv'; 
                    document.body.appendChild(link);
                    link.click();
                     this.$toast.success("Physical Inspection Sample file downloaded!");
          })
          .catch(error => {
            this.number = 0;
            this.$toast.error(error.response.data.message);
          });
      }
    }
}
</script>

<style scoped>
  .filter_style{
      max-width: 300px;
      margin-bottom: 18px;
      height: 52px;
  }
  .v-dialog:has(.filter-repair){
  justify-content: right;
  align-items: baseline;
  top: var(--dialog-ypos);
}
  .search_style{
      max-width: 300px;
  }
  .addeditems{
    display: flex;
    float: left;
    padding: 4px;
    border: 1px solid #9e9e9e;
    border-radius: 10px;
    margin: 0px 4px 4px 0px;
  }
  .closeitems{
    width: 15px !important;
    height: 15px !important;
    margin-top: 4px;
    margin-left: 3px;
  }
  .status-items{
    font-size:14px;
    font-weight: 600;
    color: #9c9c9c;
  }
  .item-selected{
    margin-top: 23px;
    position: absolute;
    left: 41%;
  }
  .v-field-label{
  color:blue !important;
  }
  @media (max-height: 1104px) {
    .PaddingItemPerPage {
      padding: 8px !important;
    }
  }
  @media (min-height: 1126px) {
    .PaddingItemPerPage{
      padding: 24px !important;
    }
  }
  :deep(.radio-styles .v-label){
    top: 6px !important;
  }
  .custom-control_outlined .v-expansion-panel:before {
    box-shadow: none;
  }

  .custom-control_outlined button {
    min-height: 52px;
    border-width: 1px;
    border-color: rgba(0, 0, 0, .42);
    border-style: solid;
  }

  .custom-control_outlined button:focus {
    outline: none;
  }
  .v-data-table {
    height: calc(var(--vh, 1vh) * 100 - 303px) !important;
  } 
  .filter_ui{
    margin-left: 10px !important;
    margin-top: 10px !important;
  }
  .disabled-link{
    pointer-events: none;
    opacity: 0.5;
    cursor: not-allowed;
  }
</style>
